export const couponOffersDataKeys: { [key: string]: string } = {
    conceptID: 'number',
    webLocationID: 'number',
    dbaName: 'string',
    stateName: 'string',
    couponCode: 'string',
    statusCode: 'string',
    enableFeaturedOffers: 'boolean',
    isActive: 'boolean',
    latestVersion: 'string',
    serviceCategories: 'object',
    serviceSkus: 'object',
    displayOffer: 'string',
    offerType: 'string',
    serviceTypeID: 'number'
};
